import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import SideBar from "../../common/sideBar";
import { axiosInstnace as Axios } from "../../../../util/util";
import { endPoints } from "../../../../config";
import useModel from "../../common/useModel";
import Model from "../../common/baseDiscountModel";
import DeleteModal from "../../common/deleteConfirmation";
import AddDiscountModel from "../../common/addBaseDiscountModel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import HeaderAdminpanel from "../../common/HeaderAdminpanel";  

const Discounts = (props) => {
  //Set Initial state
  const [packages, handlePackage] = useState([]);
  const { isShowing, toggle } = useModel();
  const { isRejectShowing, rejectToggle } = useModel();
  const { isShowAddDiscount, addDiscount } = useModel();
  const [rates, handleRates] = useState([]);

  const [rangefrom, handleRangefrom] = useState(undefined);
  const [rangeto, handleRangeto] = useState(undefined);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  const [showDialog, setShowDialog] = React.useState(false);
  const cancelRef = React.useRef();
  const open = () => setShowDialog(true);
  const close = () => setShowDialog(false);

  useEffect(() => {
    getPackage();
  }, []);

  //Update rate for budget bassed package
  const updateRate = async (params) => {
    try {
      const data = await Axios.put(endPoints.updateBaseDiscount, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Changes successfully updated", {
          position: toast.POSITION.TOP_CENTER,

          hideProgressBar: true,
          toastId: "1",
        });
        toggle();
        getPackage(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteBaseDiscount = async (params) => {
    try {
      const data = await Axios.post(endPoints.deleteBaseDiscount, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Discount Deleted Sucessfully", {
          position: toast.POSITION.TOP_CENTER,

          hideProgressBar: true,
          toastId: "1",
        });
        rejectToggle();
        getPackage(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addBaseDiscount = async (params) => {
    try {
      const data = await Axios.post(endPoints.addBaseDiscount, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Discount Added Sucessfully", {
          position: toast.POSITION.TOP_CENTER,

          hideProgressBar: true,
          toastId: "1",
        });
        addDiscount();
        getPackage(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Get package Info
  const getPackage = async () => {
    try {
      const data = await Axios.get(endPoints.getBaseDiscounts);
      const result = data.data.data.data;
      if (result) {
        console.log("Result", result);
        handlePackage(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Open model
  const openPopup = (rates, next, previous) => {
    handleRates(rates);
    if (!next) {
      handleRangefrom(previous);
      handleRangeto(rates.discount);
    } else {
      handleRangefrom(rates.discount);
      handleRangeto(next);
    }
    toggle();
  };

  //delete
  const openDeletePopup = (rates) => {
    console.log(rates);
    handleRates(rates);
    rejectToggle();
  };

  //Open Add Model
  const openAddPopup = () => {
    addDiscount();
  };

  return (
    <div className="dashboardContainer">
      <Model
        isShowing={isShowing}
        hide={toggle}
        rates={rates}
        rangefrom={rangefrom}
        rangeto={rangeto}
        updateRate={updateRate}
      />

      <DeleteModal
        isShowing={isRejectShowing}
        hide={rejectToggle}
        rates={rates}
        deleteBaseDiscount={deleteBaseDiscount}
      />

      <AddDiscountModel
        isShowing={isShowAddDiscount}
        hide={addDiscount}
        addDiscount={addBaseDiscount}
      />

<HeaderAdminpanel/>

      {/* <div className="navbar-header dashboard-header clearfix">
        <div className="logo-dashboard">
          <a id="logo">
            <img className="logo-trans" src="/assets/images/new_logo.png" />
          </a>
          <span>Welcome: {adminData.email} </span>
          <span>Last Login @ {moment(adminData.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
        </div>
        <div
          className="user-profile pull-right"
          tabIndex={0}
          onClick={() => {
            localStorage.removeItem("adminInfo");
            window.location.href = "/admin/login";
          }}
        >
          <a>
            <span>
              LOGOUT
              <span className="log_img">
                <img src="/assets/images/ic_logout.png" />
              </span>
            </span>
          </a>
        </div>
      </div> */}
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar />
        </section>
        <section id="dashboard-rightContainer" className="dashboard-manageSales">
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Manage Discount |
              <span className="breadcrumb-active fct-breadcrumb">Manage Base Discount</span>
            </div>
            {localStorage.getItem("adminRole") && localStorage.getItem("adminRole") === "admin" && (
              <div className="search_camp">
                <button onClick={openAddPopup} className="search_camp_btn">
                  ADD
                </button>
              </div>
            )}
          </div>

          <div className="dashboard-content userListing-dashboard bg-white table-responsive">
            <table className="table table-striped master-table">
              <thead>
                <tr>
                  <th> Range From</th>
                  <th> Range To</th>
                  <th>Discount</th>
                  <th>Actions</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {packages.map((r, i) => (
                  <tr>
                    <td>{r.totalSecondagesFrom}</td>
                    <td>{r.totalSecondagesTo}</td>
                    <td>{r.discount}</td>

                    <td className="">
                      <a>
                        <span
                          className="tooltip-reject fct-edit"
                          onClick={openPopup.bind(
                            this,
                            r,
                            packages[i + 1] ? packages[i + 1].discount : undefined,
                            packages[i - 1] ? packages[i - 1].discount : undefined
                          )}
                        >
                          <img src="/assets/images/edit.png" />
                          <span>Edit</span>
                        </span>
                      </a>
                    </td>
                    <td className="txt-cntr">
                      <a>
                        <span
                          className="tooltip-reject fct-edit"
                          onClick={openDeletePopup.bind(this, r)}
                        >
                          <img
                            src="/assets/images/delete.png"
                            className="reject-approved-img reject-png"
                          />
                          <span>Delete</span>
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="paginationTable"></div>
          </div>
        </section>
      </div>
      <ToastContainer />
    </div>
  );
};

export default connect(null, {})(Discounts);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/managePackage.js/discounts.js